export type BooleanFunction = typeof BOOLEAN_FUNCTIONS;

function arrayContainsElementWithValueAtPath(props: {
  array: any[];
  value: any | any[];
  path: string;
}): boolean {
  const { array, value, path } = props;
  if (!array || !Array.isArray(array)) {
    return false;
  }
  for (const item of array) {
    if (Array.isArray(value)) {
      if (value.includes(item[path])) {
        return true;
      }
    } else {
      if (item[path] === value) {
        return true;
      }
    }
  }
  return false;
}

function objectContainsValueAtPath(props: {
  obj: any;
  value: any | any[];
  path: string;
}): boolean {
  const { obj, value, path } = props;
  if (!obj || !value || !path) {
    return false;
  }

  if (typeof obj === "object") {
    if (Array.isArray(value)) {
      return value.includes(obj[path]);
    }
    return obj[path] === value;
  }
  return false;
}

/**
 * True if value is not in array
 */
function arrayNotIncludes(props?: { value: unknown; array: unknown[] }) {
  return !props?.array?.includes(props.value);
}

/**
 *  True if value matches the pattern.
 */
function stringPatternMatch(props?: { value: unknown; pattern: string }) {
  if (typeof props?.value === "string" && typeof props.pattern === "string")
    return new RegExp(props.pattern).test(props.value);

  return false;
}

export const BOOLEAN_FUNCTIONS = {
  arrayContainsElementWithValueAtPath,
  arrayNotIncludes,
  stringPatternMatch,
  objectContainsValueAtPath,
} as const;
